module.exports = __webpack_public_path__ + "static/media/4p_website_logo_sup_lscm.2cd0c71b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4p_website_logo_sup_lscm.jpg
// module id = 69
// module chunks = 0